import { MutationTree } from "vuex";
import ReportStoreTypes from "./define-types.store";

import { ReportPrintTemplateModel } from './../../../models/report/report-print-template.model';
import { PropertyAutoComplete } from './../../../models/autocomplete/property.autocomplete.model';
import { IReportState } from "../../report/states.store";
import {
  IReportPrintTemplateModel,
  ReportPrintTemplateUpdateModel,
  ReportPrintTemplateTemplatesLookupModel,
  ReportDocumentModelDto,
  ReportPrintTemplateLookupModel
} from "../../../models/report";
import { IDemandAutoComplete, IPersonAutoComplete } from "../../../models/autocomplete";

const descriptionMutations: MutationTree<IReportState> = <MutationTree<IReportState>>{
   /** STORE TO STATE */
   [ReportStoreTypes.Set.INIT_PRINTTEMPLATE]: (
    state: IReportState,
    type: string
  ) => {
    state.printTemplate = new ReportPrintTemplateModel({Module: type});
    state.printTemplateLookup = new ReportPrintTemplateLookupModel()
  },

  /** STORE TO STATE */
  [ReportStoreTypes.Set.STORE_PRINTTEMPLATE]: (
    state: IReportState,
    model: IReportPrintTemplateModel
  ) => {
    state.printTemplate = model;
  },
   /** ADD DEMANDS LOOKUPS */
   [ReportStoreTypes.Set.SET_LOOKUP_DEMANDS]: (
    state: IReportState,
    model: IDemandAutoComplete[]
  ) => {
    state.printTemplateLookup.Demands = model;
  },
  /** ADD DEMANDS LOOKUPS */
  [ReportStoreTypes.Set.SET_LOOKUP_PERSONS]: (
    state: IReportState,
    model: IPersonAutoComplete[]
  ) => {
    state.printTemplateLookup.Persons = model;
  },
  /** ADD PROPERTIES LOOKUPS */
  [ReportStoreTypes.Set.SET_LOOKUP_PROPERTIES]: (
    state: IReportState,
    model: PropertyAutoComplete[]
  ) => {
    state.printTemplateLookup.Properties = model;
  },

    /** ADD PROJECTS LOOKUPS */
    [ReportStoreTypes.Set.SET_LOOKUP_PROJECTS]: (
      state: IReportState,
      model: PropertyAutoComplete[]
    ) => {
      state.printTemplateLookup.Projects = model;
    },

  /** ADD DOCUMENT LOOKUPS */
  [ReportStoreTypes.Set.SET_LOOKUP_DOCUMENTS]: (
    state: IReportState,
    model: ReportDocumentModelDto[]
  ) => {
    state.printTemplateLookup.Documents = model;
  },

  /** ADD TEMPLATE LOOKUPS*/
  [ReportStoreTypes.Set.SET_LOOKUP_TEMPLATES]: (
    state: IReportState,
    model: ReportPrintTemplateTemplatesLookupModel
  ) => {
    state.printTemplateLookup.Templates = model;
  },

  /** UPDATE STATE */
  [ReportStoreTypes.Set.UPDATE_PRINTTEMPLATE]: (
    state: IReportState,
    updateModel: ReportPrintTemplateUpdateModel
  ) => {
    if (!state.printTemplate) return;
    state.printTemplate[updateModel.Field] = updateModel.Value;
  },

  /** UPDATE ITEM TO ARRAY FIELD STATE */
  [ReportStoreTypes.Set.UPDATE_iTEM_ARRAY_FIELD_PRINTTEMPLATE]: (
    state: IReportState,
    updateModel: ReportPrintTemplateUpdateModel
  ) => {
    if (!state.printTemplate) return;

    // REMOVE ALL OLDS ITEM
    let items = state.printTemplate[updateModel.Field];
    if (items != null && items.length > 0) {
      for (let index = 0; index < items.length; index++) {
        state.printTemplate[updateModel.Field].splice(index, 1);
      }
    }

    // UPDATE NEW ITEMS
    state.printTemplate[updateModel.Field] = updateModel.Value;
  },

  /** PUSH ITEM TO ARRAY FIELD STATE */
  [ReportStoreTypes.Set.PUSH_iTEM_ARRAY_FIELD_PRINTTEMPLATE]: (
    state: IReportState,
    updateModel: ReportPrintTemplateUpdateModel
  ) => {
    if (!state.printTemplate) return;
    if (!state.printTemplate[updateModel.Field])
      state.printTemplate[updateModel.Field] = [];
    let existItem = state.printTemplate[updateModel.Field].find(
      c => c.Id == updateModel.Value.Id
    );
    if (existItem) return;
    state.printTemplate[updateModel.Field].push(updateModel.Value);
  },

  /** REMOVE ITEM FROM ARRAY FIELD STATE */
  [ReportStoreTypes.Set.REMOVE_ITEM_ARRAY_FIELD_PRINTTEMPLATE]: (
    state: IReportState,
    updateModel: ReportPrintTemplateUpdateModel
  ) => {
    if (!state.printTemplate) return;
    if (!state.printTemplate[updateModel.Field])
      state.printTemplate[updateModel.Field] = [];
    let arr = [];
    arr = state.printTemplate[updateModel.Field];
    let index = arr.indexOf(updateModel.Value);
    if (index > -1) state.printTemplate[updateModel.Field].splice(index, 1);
  },
};

export default descriptionMutations;
